import { render, staticRenderFns } from "./LoginModalForm.vue?vue&type=template&id=16a051f9&scoped=true&"
import script from "./LoginModalForm.vue?vue&type=script&lang=js&"
export * from "./LoginModalForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginModalForm.vue?vue&type=style&index=0&id=16a051f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a051f9",
  null
  
)

export default component.exports